import { Button, Separator } from "@dune/ui";
import { ArrowRight } from "lucide-react";
import { useFormContext } from "react-hook-form";
import GFAFinancingCommercializationPlanContainer from "../../component/gfa/GFAFinancingCommercializationPlanContainer";
import GFAFinancingFundRaisingsContainer from "../../component/gfa/GFAFinancingFundRaisingsContainer";
import GFAFinancingPlanContainer from "../../component/gfa/GFAFinancingPlanContainer";
import GFAFinancingsDetailsContainer from "../../component/gfa/GFAFinancingsDetailsContainer";
import GFAFinancingsSummaryContainer from "../../component/gfa/GFAFinancingsSummaryContainer";
import { GFAFinancingsFormData } from "../../component/gfa/useGFAFinancingsForm";

interface GFAFinancingsFormProps {
	onSubmit: (data: GFAFinancingsFormData & { isNext?: boolean }) => void;
}

const GFAFinancingsForm = ({ onSubmit }: GFAFinancingsFormProps) => {
	const { getValues, handleSubmit } = useFormContext<GFAFinancingsFormData>();
	return (
		<div className="flex items-center justify-center p-6 w-full">
			<form
				onSubmit={handleSubmit(onSubmit)}
				className="flex-3 flex-col items-center justify-center p-4 w-full"
			>
				<div className="flex flex-col gap-6 w-full">
					<div className="flex flex-row gap-4">
						<h1 className="text-[#144C65] text-2xl font-medium">
							Financement de l'opération
						</h1>
					</div>

					{/* Financial Table */}
					<GFAFinancingsDetailsContainer />
					<GFAFinancingsSummaryContainer />
					<Separator />

					<GFAFinancingPlanContainer />
					<Separator />
					<GFAFinancingCommercializationPlanContainer />
					<Separator />
					<GFAFinancingFundRaisingsContainer />
					<Separator />

					{/* Action buttons */}
					<div className="self-end flex flex-row gap-4">
						<Button
							className="self-end"
							type="button"
							variant="outline"
							onClick={() => {
								onSubmit?.({
									...getValues(),
									isNext: false,
								});
							}}
						>
							Enregistrer et fermer
						</Button>
						<Button
							className="self-end"
							type="button"
							variant="default"
							onClick={() => {
								onSubmit?.({
									...getValues(),
									isNext: true,
								});
							}}
						>
							Suivant
							<ArrowRight className="w-4 h-4" />
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
};

export default GFAFinancingsForm;
